import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { FlipcardSide, SlideFlipcardsDTO } from '../../../common/models';
import { FlipCardSideComponent } from '../flipcard-side/flipcard-side.component';
import { AbstractControl } from '@angular/forms';


@Component({
    selector: 'lib-flipcard',
    templateUrl: './flipcard.component.html',
    styleUrls: ['./flipcard.component.scss'],
    standalone: false
})
export class FlipCardComponent implements OnInit, OnChanges {
  @ViewChildren(FlipCardSideComponent) public flipcardSides: QueryList<FlipCardSideComponent>;
  
  @Input() item!: SlideFlipcardsDTO;

  @Input() slide: any;
  @Input() flipcardFormGroup: AbstractControl;
  @Input() backgroundPresigned = true;
  @Input() canEdit = false;
  @Input() isTranslation?: boolean;
  @Input() isRtl?: boolean;
  @Input() errors?: any;

  @Output() edit: EventEmitter<void> = new EventEmitter();
  @Output() changeOrientation: EventEmitter<void> = new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();
  @Output() cardFlipped: EventEmitter<boolean> = new EventEmitter();

  public flipped = false;
  public allowFlipOnClick = false;
  public mousePosition: any = {};

  public frontBackground = null;
  public backBackground = null;

  public sides: typeof FlipcardSide = FlipcardSide;

  constructor() { }

  ngOnInit() {
    this.setAllowFlipOnClick();
    this.setCardMediBackgrounds();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const itemChanged = changes['item']?.previousValue !== changes['item']?.currentValue;
    const bgChanged = changes['backgroundPresigned']?.previousValue !== changes['backgroundPresigned']?.currentValue;

    if (itemChanged || bgChanged) {
      this.setCardMediBackgrounds();
    }
  }

  toggleFlip() {
    this.flipped = !this.flipped;
    this.cardFlipped.emit(this.flipped);

    const [front, back] = this.flipcardSides.toArray();
    const currentSide = this.flipped ? back : front;

    this.setAllowFlipOnClick();
    
    setTimeout(() => {
      currentSide?.startMedia();
    }, 100);
  }

  flipOnClick(event: MouseEvent): void {
    if (
      !this.allowFlipOnClick
      || Math.abs(this.mousePosition.x - event.screenX) > 10
      || Math.abs(this.mousePosition.y - event.screenY) > 10
    ) {
      return;
    }

    this.toggleFlip();
  }

  public onMouseDown(event) {
    this.mousePosition.x = event.screenX;
    this.mousePosition.y = event.screenY;
  }

  private setAllowFlipOnClick(): void {
    this.allowFlipOnClick = this.flipped
      ? !!(this.item.backText || this.item.backBackgroundColor || this.item.backMediaBackground)
      : !!(this.item.frontText || this.item.frontBackgroundColor || this.item.frontMediaBackground)
  }

  private setCardMediBackgrounds(): void {
    this.frontBackground = {
      backgroundColor: this.item?.frontBackgroundColor, mediaBackground: this.item?.frontMediaBackground, backgroundPresigned: this.backgroundPresigned
    };

    this.backBackground = {
      backgroundColor: this.item?.backBackgroundColor, mediaBackground: this.item?.backMediaBackground, backgroundPresigned: this.backgroundPresigned
    };
  }
}
